import { put, select } from 'redux-saga/effects'
import { PermissionLevels } from 'utils/permission'
import {
  addList as addListToView,
  removeList as removeListFromView,
  setPermissionLevel
} from '../redux/view'
import {
  set as setSettings
} from '../redux/settings'
import {
  add as addList,
  remove as removeList,
  addCardToList,
  removeCards as removeCardsFromList,
  removeCardFromList,
  setName as setListName,
  setSettings as setListSettings,
  setPositions as setListPositions
} from '../redux/lists'
import {
  add as addCard,
  remove as removeCard,
  set as setCard,
  addArray as addCards,
  removeArray as removeCards,
  setPositions as setCardPositions
} from '../redux/cards'
import {
  add as addVisitor,
  remove as removeVisitor
} from '../redux/visitors'
import {
  refresh as refreshDates
} from '../redux/dates'

const getListByVCardId = (state, vCardId) => {
  let list = null

  const listKeys = Object.keys(state['view-myboard'].lists)
  const length = listKeys.length

  if (length) {
    for (let i = 0; i < length; i++) {
      const _list = state['view-myboard'].lists[listKeys[i]]
      if (_list.cards.indexOf(vCardId) !== -1) {
        list = _list
        break
      }
    }
  }

  return list
}

export default function * channelData (action) {
  const { channel, actionName, elementName, data } = action.payload

  const state = yield select()

  const myBoardId = state['view-myboard'].view.id

  const currentUserId = state.kanbo.currentUser.id

  if (channel === 'vboard-' + myBoardId) {
    if (elementName === '/Positions/VCards') {
      const { Positions } = data

      if (Positions.length) {
        yield put(setCardPositions(Positions.map(Position => ({
          id: Position.Id,
          position: Position.Position
        }))))
      }
    } else if (actionName + elementName === 'ChangeParent/Data/Move<VCard>') {
      const { ContainerFromId, ContainerToId, ElementId, Position } = data
      yield put([
        removeCardFromList({
          listId: ContainerFromId,
          cardId: ElementId
        }),
        addCardToList({
          listId: ContainerToId,
          cardId: ElementId,
          position: Position
        }),
        setCard({
          id: ElementId,
          data: {
            position: Position
          }
        })
      ])
    } else if (actionName + elementName === 'AddVCard/Data/VCard') {
      const { Id, CardId, ContainerId, Position } = data
      yield put([
        addCard({
          id: Id,
          cardId: CardId,
          position: Position
        }),
        addCardToList({
          listId: ContainerId,
          cardId: Id
        }),
        refreshDates()
      ])
    } else if (actionName + elementName === 'AddCardsToMyBoard/Data/VCardData[]') {
      const VCards = data

      yield put(addCards(
        VCards.map(VCard => ({
          id: VCard.Id,
          cardId: VCard.CardId,
          position: VCard.Position
        }))
      ))

      const length = VCards.length
      for (let i = 0; i < length; i++) {
        const { Id, ContainerId } = VCards[i]

        yield put([
          addCardToList({
            listId: ContainerId,
            cardId: Id
          }),
          refreshDates()
        ])
      }
    } else if (actionName + elementName === 'RemoveVCard/Data/VCard') {
      const { Id } = data

      const list = getListByVCardId(state, Id)
      if (list) {
        yield put(removeCardFromList({
          listId: list.id,
          cardId: Id
        }))
      }
      yield put([
        removeCard({
          id: Id
        }),
        refreshDates()
      ])
    } else if (actionName + elementName === 'RemoveCardsInVList/Data/VListCards') {
      const { Id, VCardIds } = data

      yield put([
        removeCardsFromList({
          id: Id,
          cardIds: VCardIds
        }),
        refreshDates()
      ])
      yield put(removeCards(VCardIds))
    } else if (actionName + elementName === 'RemoveVCards/Data/Array<Int32>') {
      const VCardIds = data
      const length = VCardIds.length
      for (let i = 0; i < length; i++) {
        const id = VCardIds[i]
        const list = getListByVCardId(state, id)
        if (list) {
          yield put(removeCardFromList({
            listId: list.id,
            cardId: id
          }))
        }
      }
      yield put([
        removeCards(VCardIds),
        refreshDates()
      ])
    } else if (actionName + elementName === 'AddVList/Data/VList') {
      const { Id, Name, Settings, Position } = data
      yield put(addList({
        id: Id,
        name: Name,
        isLoaded: true,
        settings: {
          color: Settings.Color,
          wipLimit: Settings.WIPLimit,
        }
      }))
      yield put(addListToView({
        id: Id,
        index: Position
      }))
    } else if (actionName + elementName === 'RemoveVList/Data/VList') {
      const { Id } = data
      yield put(removeListFromView({
        id: Id
      }))
      yield put(removeList({
        id: Id
      }))
    } else if (elementName === '/Positions/VLists') {
      const { Positions } = data

      if (Positions.length) {
        yield put(setListPositions(Positions.map(Position => ({
          id: Position.Id,
          position: Position.Position
        }))))
      }
    } else if (actionName + elementName === 'RenameVList/Data/VList') {
      const { Id, Name } = data
      yield put(setListName({
        id: Id,
        name: Name
      }))
    } else if (actionName + elementName === 'ChangeVListSettings/Data/Settings') {
      const { Id, Settings } = data
      yield put(setListSettings({
        id: Id,
        settings: {
          color: Settings.Color,
          wipLimit: Settings.WIPLimit,
        }
      }))
    } else if (actionName + elementName === 'AddVBoardUser/Data/VBoardUser') {
      const { UserId, PermissionLevel } = data
      if (PermissionLevel === PermissionLevels.VISITOR) {
        yield put(addVisitor({
          id: UserId
        }))

        if (UserId === currentUserId) {
          yield put(setPermissionLevel({
            permissionLevel: PermissionLevels.VISITOR
          }))
        }
      }
    } else if (actionName + elementName === 'RemoveVBoardUser/Data/VBoardUser') {
      const { UserId, PermissionLevel } = data
      if (PermissionLevel === PermissionLevels.VISITOR) {
        yield put(removeVisitor({
          id: UserId
        }))

        if (UserId === currentUserId) {
          yield put(setPermissionLevel({
            permissionLevel: PermissionLevels.NONE
          }))
        }
      }
    } else if (actionName + elementName === 'ChangeVBoardSettings/Data/Settings') {
      const { Settings } = data

      yield put(setSettings({
        syncType: Settings.SyncType,
        cardAdderSettings: {
          responsible: Settings.CardAdderSettings.Responsible,
          coworker: Settings.CardAdderSettings.Coworker,
          listId: Settings.CardAdderSettings.ListId
        }
      }))
    }
  }
}
